import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper1 = new Swiper(".section1 .swiper", {
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20, 
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0, 
      }
    }  
}); 
var swiper2 = new Swiper(".section2 .swiper", {
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3.34,
        slidesPerGroup: 3.34,
        spaceBetween: 20, 
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0, 
      }
    }  
}); 
var swiper3 = new Swiper(".section3 .swiper", {
    navigation: {
        nextEl: ".section3 .swiper-button-next",
        prevEl: ".section3 .swiper-button-prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20, 
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0, 
      }
    }  
}); 
var swiper4 = new Swiper(".section4 .swiper", {
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3.34,
        slidesPerGroup: 3.34,
        spaceBetween: 20, 
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0, 
      }
    }  
}); 
var swiper5 = new Swiper(".section5 .swiper", {
    navigation: {
        nextEl: ".section5 .swiper-button-next",
        prevEl: ".section5 .swiper-button-prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20, 
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0, 
      }
    }  
}); 
var swiper6 = new Swiper(".section6 .swiper", {
    navigation: {
        nextEl: ".section6 .swiper-button-next",
        prevEl: ".section6 .swiper-button-prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3.34,
        slidesPerGroup: 3.34,
        spaceBetween: 20, 
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0, 
      }
    }  
}); 

var swiper7 = new Swiper(".section7 .swiper", {
    navigation: {
        nextEl: ".section7 .swiper-button-next",
        prevEl: ".section7 .swiper-button-prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3.34,
        slidesPerGroup: 3.34,
        spaceBetween: 20, 
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0, 
      }
    }  
}); 